/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

// TODO: alert-* types are deprecated and should be removed before 1.0!
export const /** @type {?} */ ALERT_TYPES: string[] =
    ["alert-info", "alert-warning", "alert-danger", "alert-success", "info", "warning", "danger", "success"];